<ul *ngIf="!hideBreadCrumbs" class="breadcrumb m-0">
  <li *ngFor="let breadcrumb of breadCrumbs">
    <a
      [routerLink]="breadcrumb.url"
      routerLinkActive="router-link-active"
      href="#"
      >{{ breadcrumb.label }}</a
    >
  </li>
</ul>
